/*
  Brisa: busca dentro de um filtro de faceta.

  Netshoes e Centauro poem um campo de busca dentro dos filtros grandes (Marca,
  Tamanho) porque a lista nao cabe na tela. Com o catalogo cheio a Brisa passa de
  trinta marcas, e trinta checkbox viram rolagem.

  Filtra sobre o que ja esta na pagina, sem ir ao servidor: responde a cada tecla.

  Amarra com o "mostre mais" do tema (show-more-item hidden): enquanto a busca
  esta ativa, TODOS os itens que casam aparecem, inclusive os que o "mostre mais"
  tinha escondido. Sem isso, buscar "umbro" nao acharia nada se Umbro estivesse
  na posicao 13 da lista.
*/
customElements.define(
  'brisa-busca-faceta',
  class extends HTMLElement {
    connectedCallback() {
      this.campo = this.querySelector('input');
      this.vazio = this.querySelector('.brisa-busca-faceta__vazio');
      this.lista = this.parentElement.querySelector('ul');
      if (!this.campo || !this.lista) return;

      this.itens = [...this.lista.querySelectorAll('li')];
      this.campo.addEventListener('input', () => this.filtrar());
      // Esc limpa, que e o que se espera de um campo de busca
      this.campo.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.campo.value = '';
          this.filtrar();
        }
      });
    }

    filtrar() {
      const termo = this.campo.value.trim().toLowerCase();
      let achou = 0;

      this.itens.forEach((item) => {
        if (!termo) {
          // sem termo, devolve o estado original: o "mostre mais" volta a mandar
          item.hidden = false;
          item.classList.toggle('hidden', item.classList.contains('show-more-item') && !this.mostrandoTudo());
          return;
        }
        const casa = item.textContent.toLowerCase().includes(termo);
        item.hidden = !casa;
        if (casa) {
          item.classList.remove('hidden');
          achou += 1;
        }
      });

      if (this.vazio) this.vazio.hidden = !termo || achou > 0;
      const botao = this.parentElement.parentElement.querySelector('.button-show-more');
      if (botao) botao.hidden = Boolean(termo);
    }

    mostrandoTudo() {
      const botao = this.parentElement.parentElement.querySelector('.button-show-more .label-show-more');
      return botao ? botao.classList.contains('hidden') : false;
    }
  }
);
